import React from 'react';
import { TableRow, TableCell, Checkbox, IconButton, Chip, Avatar } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import dayjs from 'dayjs';

const ClientsTableRow = ({
    client,
    index,
    perms,
    selectedIds,
    onRowCheckboxClick,
    onMenuOpen,
    page,
    perPage,
    isArabic,
}) => {
    const isSelected = selectedIds.includes(client.id);

    return (
        <TableRow hover selected={isSelected}>
            <TableCell padding="checkbox">
                <Checkbox
                    checked={isSelected}
                    onClick={(event) => onRowCheckboxClick(event, client.id)}
                />
            </TableCell>

            {/* S/N */}
            <TableCell align={isArabic ? 'right' : 'left'}>
                {(page - 1) * perPage + index + 1}
            </TableCell>

            {/* الاسم */}
            <TableCell align={isArabic ? 'right' : 'left'} sx={{ fontWeight: 500 }}>
                {isArabic 
                    ? (client?.title?.ar || client?.title?.en || (typeof client?.title === 'string' ? client.title : '-')) 
                    : (client?.title?.en || client?.title?.ar || (typeof client?.title === 'string' ? client.title : '-'))
                }
            </TableCell>

            {/* الصورة */}
            <TableCell align="center">
                {client?.image ? (
                    <Avatar
                        src={client.image}
                        alt="Logo"
                        sx={{ width: 40, height: 40 }}
                    />
                ) : (
                    <Chip label={isArabic ? "لا توجد صورة" : "No Image"} size="small" variant="outlined" />
                )}
            </TableCell>

            {/* تاريخ الإضافة */}
            <TableCell align={isArabic ? 'right' : 'left'} sx={{ whiteSpace: 'nowrap' }}>
                {client?.created_at ? dayjs(client.created_at).format('YYYY-MM-DD') : '-'}
            </TableCell>

            {/* الإجراءات */}
            <TableCell align="center">
                <IconButton onClick={(event) => onMenuOpen(event, client)}>
                    <MoreVertIcon />
                </IconButton>
            </TableCell>
        </TableRow>
    );
};

export default ClientsTableRow;